import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./views/Home";

import "./assets/css/import.css";
import "./assets/css/master.css";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </Router>
    );
};

export default App;
